import { ajaxAuth } from "@tm/utils"
import { WebserviceUrl } from "../../webserviceUrls"
import { ShowCustomArticleDefaultsResponse } from "./models"

export function showCustomArticlesDefaults() {
    const url = `${WebserviceUrl.BasketCustomArticles}/ShowDefaults`
    return ajaxAuth<ShowCustomArticleDefaultsResponse>({ url })
}
